import { createSlice } from "@reduxjs/toolkit";
import patientDetails from "@custom/rtk-apis/patients/patientDetails";

const initialState = {
  status: "",
  result:null,
  msg: "",
  loading: false,
  error: ""
};

const patientDetailSlice = createSlice({
  name: "patientListSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    console.log("----------", builder)
    builder
      .addCase(patientDetails.pending, (state, action) => {
        console.log("Pending")
        state.loading = true;
      })
      .addCase(patientDetails.fulfilled, (state, { payload }) => {
        console.log("Fulfilled", payload)
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(patientDetails.rejected, (state, { payload }) => {
        console.log("Rejected")
        state.result = payload;
        state.loading = false;
      });
  },
});

export default patientDetailSlice.reducer;
